import { useEffect, useState } from 'react';

export const useMinDelay = (enabled: boolean, ms: number) => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    setDone(false);
    const id = window.setTimeout(() => {
      setDone(true);
    }, ms);

    return () => {
      window.clearTimeout(id);
    };
  }, [enabled, ms]);

  return done;
};
